import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-action',
  imports: [RouterLink],
  templateUrl: './action.component.html',
  styleUrl: './action.component.scss',
})
export class Action {
  heading = input.required<string>();
  body = input.required<string>();
  buttonText = input.required<string>();
  link = input.required<string>();
}
